import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import App from './App';
import './index.css';

// The brand domain serves investor links only; admin routes (which need the
// .redwoodoperations.com SSO cookie) bounce to the operations host.
if (
  window.location.hostname === 'deals.redwoodcapitalgroup.com' &&
  !window.location.pathname.startsWith('/v/')
) {
  window.location.replace(
    `https://deals.redwoodoperations.com${window.location.pathname}${window.location.search}`,
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </QueryClientProvider>
  </React.StrictMode>,
);
